
export const nav = {
  home: "Home",
  about: "About Us",
  events: "Events", 
  sermons: "Sermons",
  blog: "Blog",
  contact: "Contact",
  donate: "Give",
  language: "Language"
};

export const hero = {
  title: "Enter to Worship, Leave to serve.",
  subtitle: "We are a Christ-centered church in Morrisville, PA, committed to making disciples and sharing Christ's love in our community.",
  knowUs: "Get to Know Us",
  watchSermons: "Watch Sermons"
};

export const about = {
  title: "About Us",
  location: "Morrisville, PA",
  tabs: {
    mission: "Mission",
    vision: "Vision",
    values: "Beliefs", 
    history: "Values"
  },
  mission: {
    title: "Our Mission",
    description: "Our mission centers on \"making disciples of Jesus Christ for the transformation of the world.\" This involves:",
    goals: {
      title: "Our Goals:",
      proclaim: "Proclaim the Gospel: Bring the message of salvation to all people, emphasizing the need for a personal relationship with Jesus Christ.",
      disciples: "Make disciples: Educate and form believers in the faith and help them grow in their Christian life through discipleship and mutual support.",
      spirituality: "Foster active spirituality and growth in faith.",
      sacraments: "Properly administer the sacraments as they were instituted by our Lord Jesus Christ.",
      community: "Serve and assist the community: Participate in activities that help meet the physical, emotional and spiritual needs of the community."
    },
    quote: "Therefore go and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit.",
    reference: "Matthew 28:19"
  },
  vision: {
    title: "Our Vision",
    description: "The Church's vision includes spiritual and numerical growth, positive impact on the community, and unity among believers.",
    goals: {
      title: "Our Goals:",
      growth: "Spiritual and numerical growth: Aspire to grow both in deepening the faith of its members and in expanding the community of believers.",
      impact: "Community impact: Promote community welfare through charitable works, Christian education, family support and social work.",
      unity: "Unity among believers: Foster unity within the body of Christ, promoting love towards those who are outside."
    },
    commitment: "We are dedicated to living faith in a practical way and bringing Christ's love to all people."
  },
  values: {
    title: "Our Theological Foundation (Beliefs)",
    description: "The Church holds firm beliefs, which have their foundations in the Bible, were born through the work of the Holy Spirit, are supported by reason, have been proven through the years and tested in the experience of countless believers.",
    subtitle: "We consider the following beliefs of a CHRISTIAN:",
    beliefs: {
      god: {
        title: "a) Believe in God",
        content: "We believe that there is one unique God, true Creator and Sustainer of this Universe: of infinite power, wisdom and goodness; father of all peoples and races. Who reveals his will through history, longs for his purpose to be fulfilled for each person and manifests his nature in Jesus Christ.",
        reference: "(Genesis 1:1; Joshua 24:14-15; Hebrews 1: 1-4)"
      },
      jesus: {
        title: "b) Believe in Jesus Christ",
        content: "We believe in Jesus Christ as the Son of God. That the most important and sublime events in history began in a stable, continued on a cross and culminated in the empty tomb. That Jesus Christ is the only way to come to know God and the only mediator between God and human beings. That the risen Christ is the Savior of all human beings and those who unite with Him by faith are restored in their relationships with God and are commissioned to serve as his reconciling people.",
        reference: "(John 14:6; 1 Timothy 2:5; Acts 10:40-43)"
      },
      holySpirit: {
        title: "c) Believe in the Holy Spirit",
        content: "We believe in the Holy Spirit as the living presence that works daily in the life of human beings and fulfills His will in the world. Who creates and renews the church, the community where human beings are reconciled with God and with one another.",
        reference: "(Luke 12:12; Galatians 5:16-26; 6:1-10)"
      },
      church: {
        title: "d) Believe in the Church",
        content: "We believe that the Church belongs to God and as salt and light of the world will be kept until the end of time. That God created it for the promotion of His worship and the proper administration of His Word and ordinances, for the maintenance of Christian fellowship and discipline, for the edification of believers and for witness to the world.",
        reference: "(Matthew 16:18; 1 Corinthians 12:28-31; 14:23-40)"
      },
      salvation: {
        title: "e) Believe in the Salvation of the Sinner",
        content: "We believe that all human beings are sinners. That sin, both individual and social, is subject to divine judgment and that God's grace in Christ reaches to redeem all areas of life, when repentant and with a rectifying spirit, we commit ourselves to do His will, and that it is our duty to link man with Christ, so that he may be free from sin and from any influence that may harm or destroy him.",
        reference: "(1 John 1:8; Romans 5:20-21, 6:1-14)"
      },
      humanity: {
        title: "f) Believe in Human Beings",
        content: "We believe that human beings are God's creation; who created them male and female, endowed with a rational soul and with knowledge, justice and true holiness. That in God's eyes each human being is of infinite value and that all human beings are brothers, created in His own image, endowed to fulfill His law but with the possibility of transgressing it, according to their free will. That is why we measure human institutions, whatever they may be, by their fruits on people.",
        reference: "(Genesis 1:27-28; John 11:25-27; Acts 17:26-28)"
      },
      bible: {
        title: "g) Believe in the Bible",
        content: "We believe in the Bible as the written testimony, in the Old and New Testament, of God's revelation through inspired men, in which the Church receives the word of God and through which its faith and obedience are nurtured. The Church is sure that God will continue to speak through the Scriptures in a changing world and in all forms of human culture.",
        reference: "(Joshua 1:8; Romans 15:4; 1 Peter 1:23)"
      },
      kingdom: {
        title: "h) Believe in the Kingdom of God",
        content: "We believe in the Kingdom of God as the Order of Things in which God's sovereignty is recognized, both theoretically and practically. Hence, wherever God's will is done and his sovereignty is recognized, there is the Kingdom of God.",
        reference: "(John 18:16-37; Luke 17:20-25; 2 Peter 1:10-11)"
      },
      judgment: {
        title: "i) Believe in Divine Judgment",
        content: "We believe that God is Judge of all the earth. That man is tested according to the use he makes of the gifts that God has entrusted to him: time, talents and material goods, and that even when we receive forgiveness from Jesus Christ for the misuse of our stewardship, we will have to answer for it before God.",
        reference: "(Romans 3:19; 14:12; 1 John 4:17)"
      },
      eternalLife: {
        title: "j) Believe in Eternal Life",
        content: "We believe that, by God's grace, we begin to participate in eternal life here in our world, and that we achieve it in its fullness after death if we have been able to reflect with our testimony and our entire life what the relationship with God through Jesus Christ means. We do not fear death, we know that Christ has already conquered it and that we are in His hands, which will lead us to the place that He went to prepare for us.",
        reference: "(Romans 2:6-9; 6:22-23: 1 Peter 1:3-4)"
      },
      christianExperience: {
        title: "k) Believe in Christian Experience",
        content: "We believe that every person can relate personally with God through Jesus Christ and that this experience often occurs in a single instant called conversion, but is repeated over and over again as one has communion with Christ and surrenders to Him. Those who have this experience receive assurance and peace.",
        reference: "(Romans 10:9-13; 12:1-2; John 14:27)"
      },
      spiritTestimony: {
        title: "l) Believe in the Testimony of the Spirit",
        content: "We believe that God's Spirit bears witness to my spirit that I am a child of God; that Jesus loved me and gave himself for me; that all my sins were erased and that I, even I, am reconciled with God. This testimony is for all who accept it.",
        reference: "(Romans 8:16; 1 Corinthians 2:12)"
      },
      christianPerfection: {
        title: "m) Believe in Christian Perfection",
        content: "When we speak of \"Christian Perfection,\" it is good to bear in mind that we do not mean by this that we can set ourselves up as judges of others, that we are free from sin and that we are free from temptation. We believe in \"Christian Perfection\" that is manifested in love, active goodwill toward all men and in a daily life under the dominion of God's will.",
        reference: "(1 John 4:20-21; 1 Corinthians 10:24; Ephesians 5:17, 20)"
      },
      unityBelievers: {
        title: "n) Believe in the Unity of all Believers",
        content: "We believe in the Universal Church of Jesus Christ. We are ashamed when we do not do everything possible to bring all denominations toward a closer unity of brotherhood and action and with joy we support all forces that work to unite Christians, for we need to be one so that the world may believe and to face the problems of our time.",
        reference: "(John 10:16 and John 17)"
      },
      socialTransformation: {
        title: "ñ) Believe in Christ's Power to Transform Society",
        content: "We believe that we must be concerned with personal salvation, without setting aside our social responsibility. This finds its foundation in the example of our Lord, who came to serve instead of being served, who redeemed man from sin, satisfied his need and enabled him to reintegrate him into society, as an integral being. As Christians we have a ministry to fulfill toward those around us; therefore, all the capacities and everything man possesses, has the duty to administer them as fruitful instruments that honor the Creator and has the right and responsibility to work for a society in which God's loving will is fulfilled for all.",
        reference: ""
      },
      christianLife: {
        title: "o) Christian Life",
        content: "We believe that believers are called to holiness, to love of neighbor, to justice and to obedience to Christ.",
        reference: ""
      },
      lastThings: {
        title: "p) Last Things",
        content: "We believe in the second coming of Christ, the resurrection of the dead, final judgment and eternal life.",
        reference: ""
      }
    },
    socialDeclaration: {
      title: "Our Declaration of Social Interest:",
      content: "In light of the teachings of Jesus, who taught us to love our neighbor and seek justice for him. The church recognizes its mission to preach the Gospel and at the same time attend to the social and human needs of the community. It promotes the dignity, equality and rights of all people without distinction. It fosters social justice, solidarity, aid to the poor and oppressed, and the protection of life and family. It works with a vocation of service and Christian love to improve the present and future quality of life of individuals. It seeks to be a testimony of the Kingdom of God in concrete works of love, peace and reconciliation."
    }
  },
  history: {
    title: "Our Values",
    description: "The values that guide our life as a church and community of faith:",
    values: {
      christ: {
        title: "Centrality of Christ",
        description: "Jesus is the center of everything we are and do."
      },
      bible: {
        title: "Biblical Authority",
        description: "God's Word guides our beliefs and practices."
      },
      prayer: {
        title: "Prayer and dependence on the Spirit",
        description: "We seek God's direction in everything."
      },
      worship: {
        title: "Sincere Worship",
        description: "We honor God with excellence and authenticity, in spirit and in truth."
      },
      discipleship: {
        title: "Intentional Discipleship",
        description: "We form followers of Jesus who grow and make disciples."
      },
      evangelism: {
        title: "Evangelization and Mission",
        description: "We share the Gospel locally and globally."
      },
      service: {
        title: "Love and Service",
        description: "We serve with compassion to our community and the most vulnerable."
      },
      unity: {
        title: "Unity and Community",
        description: "We walk in humility, forgiveness and cooperation in the body of Christ."
      },
      integrity: {
        title: "Integrity and Transparency",
        description: "We practice honesty, accountability and good stewardship."
      },
      stewardship: {
        title: "Generous Stewardship",
        description: "We manage time, gifts and resources for God's glory."
      },
      justice: {
        title: "Justice and Mercy",
        description: "We promote the dignity of every person and the common good."
      },
      multiplication: {
        title: "Multiplication",
        description: "We promote healthy leadership and church planting."
      }
    }
  },
  quote: "Were not our hearts burning within us while he talked with us on the road and opened the Scriptures to us?",
  reference: "Luke 24:32"
};

export const events = {
  title: "Events",
  subtitle: "Join our upcoming activities and celebrations",
  noEvents: "No events scheduled at this time. Stay tuned for future activities!",
  items: []
};

export const sermons = {
  title: "Sermons",
  subtitle: "Preaching and clips from our services",
  watchSermon: "Watch Sermon",
  items: [
    {
      title: "Where are the nine",
      pastor: "Pastor Jose Ramon Ruiz Perez",
      date: "August 24, 2025",
      videoUrl: "https://youtu.be/q24k49tgE7Y?si=ZE7u14Pm_5B5clk8",
      description: "A powerful reflection on gratitude and the importance of recognizing God's blessings in our lives."
    },
    {
      title: "Audio Sermon: A Life of Worship",
      pastor: "Pastor Jose Ramon Ruiz Perez",
      date: "September 13, 2025", 
      videoUrl: "https://youtu.be/Phgh0dSAAiQ?si=hoLBLitnE9xo3jyt",
      description: "Discovering what it means to live a life of authentic worship and how worship transforms our relationship with God."
    },
    {
      title: "The Blessing of Honoring Father and Mother",
      pastor: "Pastor J",
      date: "November 4, 2024",
      videoUrl: "https://youtu.be/wottHVse_xg?si=ckiDCNqJqRov36Oq", 
      description: "A meaningful message about the importance of honoring our parents and the blessings that come from obedience to God's commandments."
    }
  ]
};

export const blog = {
  title: "Blog", 
  subtitle: "Reflections, devotionals and teachings",
  readMore: "Read more →",
  items: [
    {
      date: "Dec 10, 2024",
      title: "The Hope of Advent",
      summary: "Reflecting on the hope we find in Christ's coming and how this hope transforms our daily lives amid difficulties."
    },
    {
      date: "Dec 5, 2024",
      title: "Living in Community", 
      summary: "The importance of Christian fellowship and how we can build each other up in faith, following the example of the early church."
    },
    {
      date: "Dec 1, 2024",
      title: "The Bread of Life",
      summary: "Exploring Jesus' words when He declared Himself as the Bread of Life and what this means for our relationship with Him."
    }
  ]
};

export const contact = {
  title: "Contact",
  address: "",
  email: "jrrp158@yahoo.com", 
  phone: "",
  addressLabel: "Address",
  phoneLabel: "Phone",
  scheduleLabel: "Service Hours",
  comingSoon: "Information coming soon",
  imageAlt: "Welcoming church entrance",
  form: {
    title: "Send us a message",
    name: "Name",
    email: "Email",
    message: "Message", 
    send: "Send Message",
    sending: "Sending...",
    namePlaceholder: "Your full name",
    emailPlaceholder: "your@email.com",
    messagePlaceholder: "Write your message here...",
    successMessage: "Message sent successfully!",
    errorMessage: "Error sending message. Please try again."
  }
};

export const donate = {
  title: "Support Our Mission",
  subtitle: "Your generosity helps us continue sharing Christ's love in our community. Every donation makes a difference in the lives we touch.",
  paypal: "PayPal",
  stripe: "Card",
  zelle: "Zelle"
};

export const footer = {
  copyright: "© 2025 House of Bread - Evangelical Church. All rights reserved.",
  note: "Bilingual content • Updated weekly"
};
